import tr from './local';

export const resources = {
  tr,
} as const;

export type Language = keyof typeof resources;
export type Namespace = keyof typeof tr;